import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from "styled-components"
import { ifProp, prop } from "styled-tools"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import slideInRight from 'react-animations/lib/slide-in-right';
import slideOutLeft from 'react-animations/lib/slide-out-left';
import slideInLeft from 'react-animations/lib/slide-in-left';
import slideOutRight from 'react-animations/lib/slide-out-right';
import TastyModal from 'components/TastyModal';
import iconSignIn from 'images/icon-signin-inverse.svg';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import { ModalBody } from "reactstrap"

const propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool
};

const defaultProps = {
  isOpen: false
};

const LoginTitle = styled.div`
  display: inline-block;
  padding-left: 30px;
  color: ${prop('theme.colors.white')};
  background-image: url('${iconSignIn}');
  background-position: 0 50%;
  background-size: 22px;
  background-repeat: no-repeat;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  font-family: ${prop('theme.fonts.condensed')};
`;

const StyledModalBody = styled(ModalBody)`
  overflow-x: hidden;
`;

const slideInRightAnimation = keyframes`${slideInRight}`;
const slideOutLeftAnimation = keyframes`${slideOutLeft}`;
const slideOutRightAnimation = keyframes`${slideOutRight}`;
const slideInLeftAnimation = keyframes`${slideInLeft}`;

const SlideContainer = styled.div`
  &.slide-enter {
    position: absolute;
    top: 0;
  }

  &.slide-enter-active {
    z-index: 1;
    position: relative;
    animation: 200ms ${ifProp('forgotPassword', slideInRightAnimation, slideInLeftAnimation)};  
  }

  &.slide-enter-done {
    z-index: 1;
  }

  &.slide-exit {
    position: absolute;
    top: 0;
  }
  
  &.slide-exit-active {
    animation: 200ms ${ifProp('forgotPassword', slideOutRightAnimation, slideOutLeftAnimation)}};
  }
  
  &.slide-exit-done {
    position: absolute;
    top: 0;
  }
`;

function LoginModal({ isOpen, toggle }) {
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  return (
    <TastyModal
      dark
      centered
      isOpen={isOpen}
      toggle={toggle}
      size='sm'
      title={<LoginTitle>Sign In</LoginTitle>}
    >
      <StyledModalBody>
        <TransitionGroup>
          <CSSTransition
            key={showForgotPassword ? 'forgot-password' : 'login'}
            timeout={195}
            classNames="slide"
          >
            <SlideContainer forgotPassword={showForgotPassword}>
              {showForgotPassword ? (
                <ResetPasswordForm onCancel={() => setShowForgotPassword(false)} />
              ) : (
                <LoginForm onForgotPasswordClick={() => setShowForgotPassword(true)} />
              )}
            </SlideContainer>
          </CSSTransition>
        </TransitionGroup>
      </StyledModalBody>
    </TastyModal>
  );
}

LoginModal.propTypes = propTypes;
LoginModal.defaultProps = defaultProps;

export default LoginModal;
